module.exports = __webpack_public_path__ + "static/UserTesting2x-32d4a209d77f0ac284bc86b84f671d13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/UserTesting2x.jpg
// module id = 2670
// module chunks = 21098653631116